import { render, staticRenderFns } from "./WorkIconCopyContact.vue?vue&type=template&id=5e6085ed"
import script from "./WorkIconCopyContact.vue?vue&type=script&lang=js"
export * from "./WorkIconCopyContact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports